import disableScroll from 'disable-scroll';

const $ = jQuery.noConflict();
const $burger = $('header .burger .hamburger');
const $nav = $('header nav');
let isMenuOpen = false;
export default {
  init() {
    // JavaScript to be fired on all pages
    $burger.on('click', () => {
        $burger.toggleClass('is-active');
        $nav.toggleClass('open');
        isMenuOpen = !isMenuOpen;

        if (isMenuOpen) {
            disableScroll.on();
        } else {
            disableScroll.off();
        }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
